import PageTitle from 'components/mobile/common/Layout/PageTitle.js'
import { Size } from 'const'
import PropTypes from 'prop-types'
import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { useScrollRestorationHook } from 'hooks'

import BackToHomeIcon from 'assets/svg/back-to-home.svg'
import WrapperLink from 'components/shard/WrapperLink'

function LayoutNoLogin({ page, title, text, textStyles, titleStyles, noMenu, noLink }) {
  const history = useHistory()
  useScrollRestorationHook()

  const goBack = () => {
    history.goBack()
  }

  return (
    <Wrapper>
      <MainWrapper>
        {window.location.pathname !== '/ninal/mypage/top' && (
          <HomeLink as={'div'} onClick={goBack} role="button" tabIndex={0}>
            前のページへ戻る
          </HomeLink>
        )}
        <Page>
          {title && <PageTitle title={title} text={text} textStyles={textStyles} titleStyles={titleStyles} />}
          {page}
        </Page>
      </MainWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  font-family: '游ゴシック体', YuGothic, '游ゴシック Medium', 'Yu Gothic Medium', '游ゴシック', 'Yu Gothic',
    -apple-system, BlinkMacSystemFont, 'Hiragino Kaku Gothic ProN', 'Noto Sans JP', 'メイリオ', Meiryo, Sans-Serif;
`
/* メイン部分 */
const MainWrapper = styled.div`
  padding-top: 60px;
`
const Page = styled.div`
  grid-column: 2;
`
/* ホームリンク部分 */
const HomeLink = styled(WrapperLink)`
  display: inline-block;
  margin-left: 20px;
  margin-bottom: 30px;
  padding-left: 2.5rem;
  font-size: ${Size.FONT.BIG};
  color: inherit;
  background-image: url(${BackToHomeIcon});
  background-repeat: no-repeat;
  background-position: center left;
  background-size: 1.3rem;
  cursor: pointer;
  font-weight: 500;
`

LayoutNoLogin.propTypes = {
  page: PropTypes.node,
  title: PropTypes.string,
  text: PropTypes.string,
  noMenu: PropTypes.bool,
  noLink: PropTypes.bool,
  textStyles: PropTypes.object,
  titleStyles: PropTypes.object,
}

export default LayoutNoLogin
